import { render, staticRenderFns } from "./TaskDone.vue?vue&type=template&id=671b18e8&scoped=true"
import script from "./TaskDone.vue?vue&type=script&lang=js"
export * from "./TaskDone.vue?vue&type=script&lang=js"
import style0 from "./TaskDone.vue?vue&type=style&index=0&id=671b18e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671b18e8",
  null
  
)

export default component.exports